<div class="navbar__header-mobile">
  <div class="navbar__header-mobile-logo-wrapper">
    <img *ngIf="mobileLogo" [src]="mobileLogo" alt="logo" class="navbar__logo--mobile">
  </div>
  <ng-container >
    <sc-icon id="hamburguer-button" icon="burger-menu" (click)="toggleMobileMenu()" *ngIf="!isMobileOpen"></sc-icon>
    <sc-icon id="close-menu-button" icon="close" (click)="toggleMobileMenu()" *ngIf="isMobileOpen"></sc-icon>
  </ng-container>
</div>
<div class="navbar__body-mobile" *ngIf="isMobileOpen">
  <sc-nav-items
    [highlightActive]="settings.highlightActive"
    [menu]="mainMenu"
    (itemClicked)="onItemClicked($event)"
  >
  </sc-nav-items>
  <div *ngIf="panelOptions" class="navbar-panel-container">
    <hr class="navbar__separator" [hidden]="!mainMenu">
    <sc-nav-panel-items
      *ngIf="panelOptions"
      [panel]="panelOptions"
      [showTooltip]="settings.showTooltip"
      (itemClicked)="onItemClicked($event)"
    >
    </sc-nav-panel-items>
  </div>
  <sc-nav-panel-submenu
   [panel]="panelOptionSelected"
   [highlightActive]="settings.highlightActive"
   (closeClicked)="onPanelSubMenuClose()"
   (itemClicked)="onItemClicked($event)"
  >
  </sc-nav-panel-submenu>
</div>
<div class="navbar__desktop-wrapper">
  <div class="navbar__aside">
    <img class="navbar__logo" *ngIf="logo" [src]="logo" alt="logo">

    <sc-nav-panel-items
      *ngIf="panelOptions"
      [panel]="panelOptions"
      [showTooltip]="settings.showTooltip"
      (itemClicked)="onItemClicked($event)"
    >
    </sc-nav-panel-items>
  </div>
  <sc-nav-panel-submenu
   [panel]="panelOptionSelected"
   [highlightActive]="settings.highlightActive"
   [firstLevel]="true"
   (closeClicked)="onPanelSubMenuClose()"
   (itemClicked)="onItemClicked($event)"
  >
  </sc-nav-panel-submenu>
  <div *ngIf="mainMenu" class="navbar__main" [class.navbar__main--collapsed]="isCollapsed">
    <sc-nav-items
      class="navbar__main-items"
      [highlightActive]="settings.highlightActive"
      [firstLevel]="true"
      [menu]="mainMenu"
      (itemClicked)="onItemClicked($event)"
    >
    </sc-nav-items>
    <div class="navbar__collapse-button" (click)="isCollapsed = !isCollapsed">
      <sc-icon
        [icon]="isCollapsed ? 'burger-menu': 'arrow-left' "
        size="0_5"
        class="navbar__collapse-button-icon"
      ></sc-icon>
    </div>
  </div>
</div>
